import { BanknotesIcon } from "@heroicons/react/24/outline";
import { Button } from "@/core/components/ui/button";
import { Card } from "@/core/components/ui/card";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { cn } from "@/core/utils/utils";

interface EmptyPaymentStateProps {
  className?: string;
  onAddBankDetails: () => void;
}

export const EmptyPaymentState = ({
  className,
  onAddBankDetails,
}: EmptyPaymentStateProps) => (
  <Card
    className={cn(
      "flex h-[400px] w-full items-center justify-center border-2 border-dashed border-muted bg-background/50",
      className,
    )}
  >
    <Stack
      direction="column"
      gap="lg"
      align="center"
      justify="center"
      fullWidth
      className="px-6"
    >
      <BanknotesIcon className="h-20 w-20 text-tertiary-text" />
      <Typography
        variant="titleW3"
        textColor="secondary"
        className="text-center"
      >
        No banking information added
      </Typography>
      <Typography
        variant="bodyW1"
        textColor="tertiary"
        className="max-w-md text-center"
      >
        Add your banking details to enable deposits and withdrawals for referral
        payments
      </Typography>
      <Button size="lg" onClick={onAddBankDetails} className="mt-4">
        Add bank details
      </Button>
    </Stack>
  </Card>
);
